import { FinancialAccountNode } from './interfaces';
import { orgsRequest } from './request';

const FINANCIAL_ACCOUNT_ORG_QUERY = `
query FinancialAccount($orgId: ID!) {
  financialAcctOrg(orgId: $orgId) {
    orgId
    orgName
    kybId
    finAcctId
    processor
    status
    acctId
    applicationId
    customerId
    createdAt
    updatedAt
    stripeEnv
    finAcctId
    paymentMethodId
  }
}`;

export async function financialAccount(
  orgId: string,
  provider: VaultProvider,
): Promise<FinancialAccountNode | undefined> {
  const financialAcctOrgRes = await orgsRequest(FINANCIAL_ACCOUNT_ORG_QUERY, {
    orgId,
  });
  const financialAcctOrgJson = await financialAcctOrgRes.json();
  return financialAcctOrgJson.data.financialAcctOrg.find(
    (fao: FinancialAccountNode) =>
      // match provider
      fao.processor === provider.toUpperCase() &&
      // must have kybId to retrieve vault data
      fao.kybId !== undefined &&
      // must have finAcctId to interact with upstream payment provider
      fao.finAcctId !== undefined &&
      // must not be terminated
      fao.status !== 'TERMINATED',
  );
}
